import React from 'react';
import ContainerImg from "../../Pages/images/latest/Container 1.png";
import HandsImg from "../../Pages/images/latest/Hands.png";
import GlobeImg from "../../Pages/images/latest/Globe.png";
import DollarImg from "../../Pages/images/latest/Dollar in hand.png";
import "./HowItWorks.css";

const HowItWorks = () => {
  const steps = [
    {
      number: 1,
      image: ContainerImg,
      title: "YOU OWN",
      description: "You purchase a shipping container."
    },
    {
      number: 2,
      image: HandsImg,
      title: "YOU HAND IT TO US",
      description: "You lease it to Brooks Container."
    },
    {
      number: 3,
      image: GlobeImg,
      title: "WE LEASE IT GLOBALLY",
      description: "We lease your container to our global trade networks."
    },
    {
      number: 4,
      image: DollarImg,
      title: "YOU EARN",
      description: "We share the monthly rental returns with you."
    }
  ];

  return (
    <div className="how-it-works-section">
      <div className="how-it-works-container">
        
        {/* Section Header */}
        <div className="how-it-works-header">
          <h2 className="how-it-works-title">
            <span className="title-dash"></span>
            HOW IT WORKS
            <span className="title-dash"></span>
          </h2>
          <p className="how-it-works-subtitle">
            A simple 4-step process to turn your container into a source of monthly income.
          </p>
        </div>

        {/* Steps Flow */}
        <div className="steps-flow-container">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              {/* Step Item */}
              <div className="step-item-box">
                <div className="step-number-badge">{step.number}</div>
                <div className="step-circle-card">
                  <img src={step.image} alt={step.title} className="step-card-img" />
                </div>
                <h3 className="step-item-title">{step.title}</h3>
                <p className="step-item-desc">{step.description}</p>
              </div>

              {/* Arrow between steps (except the last one) */}
              {index < steps.length - 1 && (
                <div className="step-flow-arrow">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

      </div>
    </div>
  );
};

export default HowItWorks;